import { cookie } from "./cookie"
import {
  setCookieDropdownValue,
  setCookieCombinedButtonValue,
} from "../helpers/util"
import { CookieType } from "../helpers/enums"

/* Check for and set currency cookie */
export const currencyCookie = () => {
  cookie(CookieType.CURRENCY, { reloadAfterSet: true })
  setCookieDropdownValue(CookieType.CURRENCY)
  setCookieCombinedButtonValue(CookieType.CURRENCY)

  window.addEventListener("resize", () => {
    setCookieCombinedButtonValue(CookieType.CURRENCY)
  })

  window.dispatchEvent(new Event("resize"))
}
